import './notification-message-ctrl';
import './message-center-service';
import './style.scss';
import './notification/component';
